import { ItemDetailLicense } from "./item-detailsLicense.model";
import { ItemBalance } from "./item-balance.model";
export class ItemDetails {
    BookingItemId: any;
    purchaseUOMDefaultDV: any;
    taxTable4Default: any;
    stockingUOMDV: any;
    salesUOMDefaultDV: any;
    productCategoryDV: any;
    alternateReportingUOM: any;

    discountTableDefault: any;
    descriptionPartial2of3: any;
    descriptionPartial1of3: any;
    createdDate: any;
    costProrationMethodDefault: any;
    createdBy: any;
    classCode: any;
    costPercent: any;
    commodity: any;
    formulaBase: any;
    inventoryItemRemarks: any;
    inventoryLocation: any;
    inventoryMisc1Code: any;
    inventoryMisc2Code: any;
    inventoryMisc3Code: any;
    inventoryMisc4Code: any;
    inventoryMisc5Field: any;
    inventoryMisc6Field: any;
    inventoryMisc7Field: any;
    itemOption: any;
    itemType: any;
    lastPhysicalCountDate: any;
    lastProductionStage: any;
    lastUpdatedBy: any;
    lastUpdatedDate: any;
    maintainOperationalCost: any;
    maximumPrice: any;
    minimumPrice: any;
    operationalCostDate: any;
    packageUOM: any;
    parentItemNumber: any;
    productCategory: any;
    purchaseOrderTolerance: any;
    purchaseUOMDefault: any;
    restrictedProduct: any;
    sqlID: any;
    salesOrderTolerance: any;
    standardRemark1: any;
    standardRemark2: any;
    standardRemark3: any;
    standardRemark4: any;
    standardRemark5: any;
    standardRemark6: any;
    standardRemark7: any;
    standardRemark8: any;
    standardRemark9: any;
    standardRemark10: any;
    stockingUOM: any;
    stockingUnitsPerPackage: any;
    taxTable1Default: any;
    taxTable2Default: any;
    taxTable3Default: any;
    tenantID: any;
    universalProductCode: any;
    useSubitems: any;
    varietyCode: any;
    weightPerStockingUOM: any;
    whereStored: any;
    inventoryBarCodes: any;


    category: string;
    categoryDescription: string;
    id: string;
    name: string;
    itemId: string;
    itemDescription: string;
    onHand: number;
    onHandUom: string;
    price: number;
    uom: string;
    location: string;
    quantity: number;
    amount: number;
    priceLevel1: number;
    priceLevel2: number;
    variancePL1: number;
    variancePL2: number;
    position: number;
    onHandOfAllLocations: string;
    positionOfAllLocations: string;
    uomschedule: string;
    defaultSellingUom: string;
    inactive: string;
    documentDate: string;
    branch: string;
    container: string;
    containerDescription: string;
    itemLicenses: ItemDetailLicense[];
    itemBalance: ItemBalance;
    lineRemarks: string;
    orderlineRemarks: string;
    isOnHandAndPositionLoaded: boolean;
    startDate: Date;
    endDate: Date;
    minDate: Date;
    IsPriceOveridden: boolean;
    shipmentTime: string;
    shipmentTimeRemarksNumber:string;
    shipmentType:string;
    shipmentTypeRemarksNumber:string;
    deliveryPointId:any;
    deliveryPointRemarksNumber:string;
    selectedItemLocations:any[];
    orderLineRemarksJson:any;
    isAllowedEdit:boolean=true;
    categoryType : string; 
    percentage:number;
    constructor(options?) {
        if (options != undefined) {
            this.category = options.category;
            this.categoryDescription = options.categoryDescription;
            this.id = options.id;
            this.name = options.name;
            this.itemId = options.itemId;
            this.itemDescription = options.itemDescription;
            this.onHand = options.onHand;
            this.onHandUom = options.onHandUom;
            this.price = parseFloat(options.price);
            this.uom = options.uom;
            this.location = options.location;
            this.quantity = 0;
            this.amount = 0;
            this.priceLevel1 = parseFloat(options.priceLevel1);
            this.priceLevel2 = parseFloat(options.priceLevel2);
            this.variancePL1 = isNaN(parseFloat(options.variancePL1)) ? 0 : parseFloat(options.variancePL1);
            this.variancePL2 = isNaN(parseFloat(options.variancePL2)) ? 0 : parseFloat(options.variancePL2);
            this.position = parseFloat(options.position);
            this.onHandOfAllLocations = options.onHandOfAllLocations;
            this.positionOfAllLocations = options.positionOfAllLocations;
            this.isOnHandAndPositionLoaded = false;
        } else {
            this.category = '';
            this.categoryDescription = '';
            this.id = '';
            this.name = '';
            this.itemId = '';
            this.itemDescription = '';
            this.onHand = 0;
            this.onHandUom = '';
            this.price = 0;
            this.uom = '';
            this.location = '';
            this.quantity = 0;
            this.amount = 0;
            this.priceLevel1 = 0;
            this.priceLevel2 = 0;
            this.variancePL1 = 0;
            this.variancePL2 = 0;
            this.position = 0;
            this.onHandOfAllLocations = '';
            this.positionOfAllLocations = '';
            this.shipmentTime = "   00:00 AM    ";
        }
        let endDateYear = new Date(Date.now()).getFullYear();
        let endDateMonth = new Date(Date.now()).getMonth() + 1;
        let endDateDate = new Date(Date.now()).getDate();
        this.startDate = new Date(Date.now());
        this.minDate = new Date(Date.now());
        this.endDate = new Date(endDateYear, endDateMonth, endDateDate);
        this.orderlineRemarks = "";
        this.shipmentTime = "   00:00 AM    ";

        this.selectedItemLocations = [];

    }
}
